<div *ngIf="!readOnly && (isAppFormReady$ | async) !== true" class="loading-screen-wrapper">
  <mat-spinner></mat-spinner>
</div>

<mat-stepper linear="true" #stepper [class.hideStepper]="hideStepper || readOnly">
  <mat-step [completed]="isContactInfoReady" [select]="activeMenuOrder === 1" label="Contact Info"></mat-step>
  <mat-step [completed]="isProductInfoReady" [select]="activeMenuOrder === 2" label="Coverage Type"></mat-step>
  <mat-step [completed]="isBusinessTypeReady" [select]="activeMenuOrder === 3" label="Business Types"></mat-step>
</mat-stepper>
<ng-container *ngIf="activeMenuOrder > 0">
  <appform-contact-info-questions
    *ngIf="(isContactInfoReady && (isAppFormReady$ | async)) || readOnly"
    class="field"
    [readOnly]="readOnly"
    [formData]="formData"
    (answerUpdate)="updateQuestionSet($event)"
  >
  </appform-contact-info-questions>
  <appform-product-info-questions
    *ngIf="(isProductInfoReady && (isAppFormReady$ | async)) || readOnly"
    class="field coverageTypes"
    [readOnly]="readOnly"
    [formData]="formData"
    (answerUpdate)="updateQuestionSet($event)"
  >
  </appform-product-info-questions>
  <appform-business-type-input
    *ngIf="isBusinessTypeReady"
    class="field"
    [isAppSyncedWithBP$]="isAppSyncedWithBP$"
    [readOnly]="readOnly"
    [formData]="formData"
    (answerUpdate)="updateQuestionSet($event)"
    (webComponentLoad)="onWebComponentLoad($event)"
  >
  </appform-business-type-input>
  <appform-question-set-save-button *ngIf="(isAppFormReady$ | async) && !readOnly"></appform-question-set-save-button>
</ng-container>
